import { Stack } from '@mui/material';
import { OrderByNewOld } from './OrderByNewOld';
import { SortBySubject } from './SortBySubject';

export const MobileFilter = () => {
  return (
    <Stack sx={{ m: '32px 0 -10px 0' }}>
      <SortBySubject />
      <OrderByNewOld />
    </Stack>
  );
};
